var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "shousai-content" } }, [
    _c(
      "div",
      {
        style:
          "background: url(" +
          _vm.userRealIntentionImageUrlForPc +
          "/back.png; " +
          _vm.innerStyle,
        attrs: { id: "shousai_inner" },
      },
      [
        _c("div", { staticClass: "mt10 ml5", attrs: { id: "shousai_width" } }, [
          _c(
            "div",
            {
              staticClass: "honne_box preview-clearfix",
              attrs: { id: "honne_box" },
            },
            [
              _c("div", { staticClass: "data_box fll tc" }, [
                _c("img", {
                  attrs: {
                    src: "" + _vm.userRealIntentionIconImageUrlForPc,
                    "data-test": "icon-url",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "profile tl" }, [
                  _c("div", { staticClass: "profile_inner fs13" }, [
                    _c("p", { staticClass: "mb15" }, [
                      _vm._v("\n                回答日 "),
                      _c("span", { attrs: { "data-test": "answer-date" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDate")(_vm.realIntention.createDate)
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { attrs: { "data-test": "content" } }, [
                        _vm._v(_vm._s(_vm.content)),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "arrow_box fll" }, [
                _c(
                  "ul",
                  {
                    style:
                      "background: url(" +
                      _vm.userRealIntentionImageUrlForPc +
                      "/q.png) no-repeat 35px 28px;",
                    attrs: { id: "question" },
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "fs14",
                        attrs: { "data-test": "question1" },
                      },
                      [
                        _vm._v(
                          "\n              1．あなたの会社はどんな会社だと思う？\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "fs14",
                        attrs: { "data-test": "question2" },
                      },
                      [
                        _vm._v(
                          "\n              2．会社の一番良いところは？\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "fs14",
                        attrs: { "data-test": "question3" },
                      },
                      [
                        _vm._v(
                          "\n              3．会社に期待していることは？\n            "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "preview-clearfix pega-pre-wrap",
                    attrs: { id: "answer" },
                  },
                  [
                    _c("li", { staticClass: "fs15" }, [
                      _c("span", [_vm._v("1．")]),
                      _vm._v(" "),
                      _c("p", {
                        attrs: { "data-test": "answer1" },
                        domProps: {
                          textContent: _vm._s(_vm.realIntention.question1),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "fs15" }, [
                      _c("span", [_vm._v("2．")]),
                      _vm._v(" "),
                      _c("p", {
                        attrs: { "data-test": "answer2" },
                        domProps: {
                          textContent: _vm._s(_vm.realIntention.question2),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "fs15" }, [
                      _c("span", [_vm._v("3．")]),
                      _vm._v(" "),
                      _c("p", {
                        attrs: { "data-test": "answer3" },
                        domProps: {
                          textContent: _vm._s(_vm.realIntention.question3),
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }